import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

export const useFavorites = () => {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState({
    stores: [],
    products: []
  });

  useEffect(() => {
    if (user) {
      fetchFavorites();
    }
  }, [user]);

  const fetchFavorites = async () => {
    try {
      const { data } = await api.get('/favorites');
      setFavorites({
        stores: data?.data?.stores || [],
        products: data?.data?.products || []
      });
    } catch (error) {
      console.error('Error fetching favorites:', error);
    }
  };

  const toggleStoreFavorite = async (storeId) => {
    try {
      const { data } = await api.post(`/favorites/stores/${storeId}`);
      setFavorites(prev => ({
        ...prev,
        stores: data.data.favorites
      }));
      return data.data.isFavorite;
    } catch (error) {
      console.error('Error toggling store favorite:', error);
      throw error;
    }
  };

  const toggleProductFavorite = async (productId) => {
    try {
      const { data } = await api.post(`/favorites/products/${productId}`);
      setFavorites(prev => ({
        ...prev,
        products: data.data.favorites
      }));
      return data.data.isFavorite;
    } catch (error) {
      console.error('Error toggling product favorite:', error);
      throw error;
    }
  };

  const isStoreFavorite = (storeId) => {
    if (!user) return false;
    return favorites?.stores?.some(store => store._id === storeId);
  };

  const isProductFavorite = (productId) => {
    return favorites?.products?.some(product => product._id === productId);
  };

  return {
    favorites,
    toggleStoreFavorite,
    toggleProductFavorite,
    isStoreFavorite,
    isProductFavorite,
    fetchFavorites
  };
};